import { F } from '@/utils/intl';
import React, { useEffect } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { useIntl, useSelector } from 'umi';
import LeadAssigneeDropdownFilters from '@/components/Filters/LeadAssigneeDropdownFilters';
import * as LeadSelectors from '@/selectors/leadSelectors';
import LeadPriorityDropdownFilters from '@/components/Filters/LeadPriorityDropdownFilters';
import LeadStateDropdownFilter from '@/components/Filters/LeadStateFilters';

const WebhookLeadSourceFormStep = ({
  isNew,
  onValuesChange,
  config,
  nextStep,
  onClose
}) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { leadSourceDetail, detailLoading } = useSelector((state: DefaultRootState) => ({
    systemFields: LeadSelectors.selectLeadFields(state),
    leadName: state.journey?.selectedJourney?.name,
    leadSourceDetail: state.leadSources.leadSourceDetail?.lead_source,
    detailLoading: state.loading.effects['leadSources/fetchLeadSource'],
  }));

  useEffect(() => {
    if (!isNew && leadSourceDetail) {
      form.setFieldsValue(leadSourceDetail);
    }
  }, [isNew, config, form]);
  const handleSubmit = () => {
    form.validateFields().then((values) => {
      nextStep();
    });
  };
  return (
    <>
      <Form
        disabled={detailLoading}
        form={form}
        layout="vertical"
        onValuesChange={onValuesChange}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              rules={[{ required: true }]}
              name="name"
              label={<F id={'common.attribute.name'} defaultMessage={'Name'} />}
              required
            >
              <Input placeholder={intl.formatMessage({
                id: 'pages.leadsources.namePlaceholder',
                defaultMessage: 'Enter the name of the source',
              })} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              rules={[{ required: true }]}
              name="incoming_lead_state_id"
              label={<F id={'pages.leadsources.csv.entryState'} defaultMessage={'Entry State'} />}
              required
            >
              <LeadStateDropdownFilter type='dropdown' filterMode={'select'} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>

          <Col span={12}>
            <Form.Item
              name="assignee_id"
              label={<F id={'pages.leadsources.assignedTo'} defaultMessage={'Assign To'} />}
            >
              <LeadAssigneeDropdownFilters
                  type="dropdown"
                  filterMode={'select'} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="priority"
              label={<F id={'pages.leadsources.priority'} defaultMessage={'Priority'} />}
            >
              <LeadPriorityDropdownFilters filterMode={'select'}  placeholder={intl.formatMessage({
                id: 'pages.leadsources.priorityIncoming',
                defaultMessage: 'Priority of incoming leads',
              })}/>
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ justifyContent: 'flex-end' }}>
          <Button type="default" onClick={onClose} style={{ margin: '0 8px' }}>
            <F id={'common.actions.cancel'} defaultMessage={'Cancel'} />
          </Button>
          <Button type="primary" htmlType="submit" onClick={handleSubmit}>
        { isNew  ?  <F id={'pages.leadsources.createWebhook'} defaultMessage={'Create Webhook'} /> : <F id={'pages.common.update'} defaultMessage={'Update'} /> }
          </Button>
        </Row>
      </Form>
    </>
  );
};

export default WebhookLeadSourceFormStep;
